$(document).ready(function() {

  if(jQuery("#shopify-section-template--21686234415421__76ba29e1-fdb3-41d1-8d29-6bc37621a33c").length) {
    jQuery("#shopify-section-template--21686234415421__76ba29e1-fdb3-41d1-8d29-6bc37621a33c").addClass("activity-goals-wrapper");
    jQuery("#shopify-section-template--21686234415421__6b4fd733-72c1-41dc-8544-04dc854657a9").addClass("improve-sleep-wrapper");
    
    jQuery("#shopify-section-template--21686234415421__76ba29e1-fdb3-41d1-8d29-6bc37621a33c").before("<div class='home-mobile-carousel'></div>");
    jQuery(".home-mobile-carousel").append(jQuery("#shopify-section-template--21686234415421__76ba29e1-fdb3-41d1-8d29-6bc37621a33c"));
    jQuery(".home-mobile-carousel").append(jQuery("#shopify-section-template--21686234415421__6b4fd733-72c1-41dc-8544-04dc854657a9"));

    if (jQuery(window).width() < 768) {
      // jQuery(document).find(".home-mobile-carousel").slick({
      //   dots: true,
      //   arrows: false,
      //   infinite: true,
      //   speed: 300,
      //   slidesToShow: 1,
      //   slidesToScroll: 1
      // });

      jQuery('.home-mobile-carousel').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false
      });
    }
  };
  
  // jQuery('[data-title="no-gallery"]').remove();
  
  function toggleMatrialVariantImages(value) {
    jQuery(".qty-thumbnail").removeClass("show");
    jQuery(".qty-thumbnail[data-option1='"+value+"']").addClass("show");
  }
  if(jQuery(".swatch-element.material").length) {
    toggleMatrialVariantImages(jQuery(".swatch_options input:checked + .swatch-element").attr("data-value"));
    jQuery(".swatch-element.material").on("click", function(){
      let value = jQuery(this).attr("data-value");
      let what_in_box_img = jQuery(this).attr("data-box");
      jQuery(".what-in-box-image").attr("src", what_in_box_img);
      toggleMatrialVariantImages(value);
    });
  }
  
  if(jQuery(".banner").length > 0 ) {
    jQuery(".banner").closest(".section").addClass("article-banner");
  }
  if(jQuery(".product-8542416961853").length > 0) {
    jQuery(".product-8542416961853").closest(".product__details").remove();
  }
  localStorage.setItem("actual_click", "no");
  $(".swatch-element.color").on("click", function() {
      localStorage.setItem("actual_click", "yes");
  });

  if($(".product-hsw3_band .product-list").length > 0) {
    $(".product-hsw3_band .product-list").flickity({
      cellAlign: 'left',
      contain: true
    });
  }
  
  
  
  if($(".option_title.color").length > 0) {
    $(".active_option.color").text(" " + $(".swatch_options input:checked + .swatch-element.color").attr("data-value"));
  }

  if($(".option_title.size").length > 0) {
    $(".option_title .active_option.size").text($(".swatch_options input:checked + .swatch-element.size").attr("data-value").split(":")[1]);
  }

  // $(document).on("click", ".swatch_options .swatches-wrapper.qty input + .swatch-element label", function(){
  //   let selected_material = $(".swatch_options .swatches-wrapper.material input:checked + .swatch-element").attr("data-value");
  //   console.log(selected_material);
  // });

  $(".swatch-element.size").on("click", function(){
    let value = $(this).attr("data-value").split(":")[1];
    $(".option_title .active_option.size").text(value);
  });

  $(".swatch-element.color").on("click", function(){
    let value = $(this).attr("data-value");
    $(".active_option.color").text(" " + value);
  });
  
  $(".quantity_wrapper #quantity_qty").change(function(){
    var val = $(this).val();
    $(".purchase-details__quantity #quantity").val(val);
  }); 
  /*get_video();*/
  
  if($("body").hasClass("product-custom_product")){
    $(".promo_banner.promo_only_product").removeClass("hide--item");
    $(".promo_banner.promo_normal").addClass("hide--item");
  }

  if(jQuery("#quantity_qty").length) {
    jQuery("#quantity_qty").on("change", function() {
      let vlue = jQuery(this).val();
      jQuery("#quantity").val(vlue);
      jQuery("#quantity").trigger("change");
    });
  }


  // On product gallery slider image change then Change the variant with it
    // jQuery(".flickity-prev-next-button.previous").on("click", function(){
    //   localStorage.setItem("fake_click", "yes");
    // });


    // jQuery(".flickity-prev-next-button.next").on("click", function(){
    //   localStorage.setItem("fake_click", "yes");
    // });
  
  
});


$(window).on("load", function() {
  console.log("Loaded!!!!!!!!!!!!!");
  // if($(document).find(".ocu-alignment__cards-container").length) {
  //   $(document).find(".ocu-alignment__cards-container").slick({
  //     dots: false,
  //     arrows: true,
  //     infinite: true,
  //     speed: 300,
  //     slidesToShow: 3,
  //     slidesToScroll: 1,
  //     responsive: [
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 1,
  //           infinite: true,
  //           dots: false
  //         }
  //       }
  //     ]
  //   });
  // }


  //Mobile fix
  setTimeout(function(){
    jQuery(".swatch_options").after(jQuery("#shopify-section-template--21802857988413__16987738231c108b85"));
    jQuery(".ocu-checkbox__indicator:eq(0)").trigger("click");
    setTimeout(function(){
      jQuery(".ocu-checkbox__indicator:eq(0)").trigger("click");
    }, 300);
    
    if($(window).width() > 768) {
      if($(document).find('.swiper-container').length) {
        $(document).find('.swiper-container').each(function(){
          this.swiper.destroy();
        });
    
        setTimeout(function(){
          const swiper = new Swiper('.swiper-container', {
            speed: 400,
            spaceBetween: 20,
            createElements: true,
            breakpoints: {
              // when window width is >= 320px
              320: {
                slidesPerView: 1,
                spaceBetween: 10
              },
              // when window width is >= 480px
              360: {
                slidesPerView: 2,
                spaceBetween: 20
              },
              // when window width is >= 640px
              768: {
                slidesPerView: 3,
                spaceBetween: 40
              }
            }
          });
          jQuery(document).on("click", ".ocu-button-navigation.next", function(){
            swiper.slideNext();
          });
    
          jQuery(document).find(".ocu-button-navigation.prev").removeAttr("disabled");
          jQuery(document).on("click", ".ocu-button-navigation.prev", function(){
            swiper.slidePrev();
          });
        }, 500);
      }
    }
    
  }, 500);
  
  
  
  $(".swatch_options input:checked + .swatch-element").trigger("click");
});
/*
function get_video(){
  setInterval(function(){
    $(".custom_video").get(0).play();
  }, 4000);
}*/